import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { Copy, Reply, Forward, Trash2, Flag } from "lucide-react";

interface MessageContextMenuProps {
  children: React.ReactNode;
  onCopy: () => void;
  onReply: () => void;
  onForward: () => void;
  onDelete: () => void;
  onFlag: () => void;
}

export function MessageContextMenu({
  children,
  onCopy,
  onReply,
  onForward,
  onDelete,
  onFlag,
}: MessageContextMenuProps) {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent className="w-64">
        <ContextMenuItem onClick={onCopy} className="cursor-pointer">
          <Copy className="mr-2 h-4 w-4" />
          <span>Copy Message</span>
        </ContextMenuItem>
        <ContextMenuItem onClick={onReply} className="cursor-pointer">
          <Reply className="mr-2 h-4 w-4" />
          <span>Reply</span>
        </ContextMenuItem>
        <ContextMenuItem onClick={onForward} className="cursor-pointer">
          <Forward className="mr-2 h-4 w-4" />
          <span>Forward</span>
        </ContextMenuItem>
        <ContextMenuItem onClick={onFlag} className="cursor-pointer">
          <Flag className="mr-2 h-4 w-4" />
          <span>Flag Message</span>
        </ContextMenuItem>
        <ContextMenuItem onClick={onDelete} className="cursor-pointer text-red-600">
          <Trash2 className="mr-2 h-4 w-4" />
          <span>Delete Message</span>
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
